import React from "react";
import PropTypes from "prop-types";
import { Select, Row, Col, Input, Spin, message } from "antd";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import StageService from "services/stage-service";
import { List } from "immutable";
import createBrowserHistory from "history/createBrowserHistory";

class ProceedModalContent extends React.Component {
    state = {
        stages: [],
        remarks: null,
        stage: null,
        user: null,
        userId: null,
        isUserDisabled: false,
        disableForm: true,
        subStatus:["POD Uploaded", "Deferral on POD", "Enhancement Case", "Case on HOLD", "E-Com Courier"],
        selectedSubStatus: ""
    };
    componentDidMount() {
        if(this.props.stageId !== 2) {
            StageService.getStages(
                this.props.stageId,
                "proceed",
                this.props.caseId
            ).then(({ data }) => {
                this.setState({
                    stages: new List(data),
                    disableForm: false
                }, () => {
                    if(this.state.stages.size === 1) {
                        this.setState({
                            stage: this.state.stages.first().id,
                            isUserDisabled: this.state.stages.first().is_bucket_available
                        }, () => {
                            this.renderUserList();
                        });
                    }
                });
            }).catch(() => {
                this.setState({
                    disableForm: false
                }, () => {
                    message.error("Internet Connectivity Issue");
                });
            });
        }
    }

    renderUserList = () => {
        let users = this.state.stages.find(_ => _.id === this.state.stage).user_list;
        if(users.length === 1 || users.size === 1) {
            this.setState({
                user: users,
                userId: users[0].id
            });
        }
    };
    // componentDidMount() {
    //     const { stagePermissions, stage } = this.props;
    //     stagePermissions.find(_ => {
    //         return _.stage_name === stage;
    //     });
    //     const { can_proceed } = stagePermissions.find(
    //         _ => _.stage_name === stage
    //     );

    //     this.setState({
    //         can_proceed_stages: this.get_proceed_stage(can_proceed || []) || []
    //     });
    // }
    // componentWillReceiveProps(nextProps) {
    //     const { stagePermissions, stage } = nextProps;
    //     const { can_proceed } = stagePermissions.find(
    //         _ => _.stage_name === stage
    //     );
    //     this.setState({
    //         can_proceed_stages: this.get_proceed_stage(can_proceed || []) || []
    //     });
    // }
    // get_proceed_stage = can_proceed_stages => {
    //     return this.props.stages
    //         .filter(_ => can_proceed_stages.includes(_.id))
    //         .toJS();
    // };
    // get_mandatory_stage = (stages, mandatory_stages) => {
    //     return stages.filter(_ => mandatory_stages.includes(_.id));
    // };

    onStageSelect = stageId => {
        this.setState({
            stage: Number(stageId),
            user: [],
            userId: null
        }, () => {
            this.renderUserList();
        });
    };
    // onStageSelect = stageId => {
    //     // const stage = this.props.stages.find(_ => _.id === stageId);
    //     this.setState(
    //         {
    //             stageId,
    //             usersLoading: true
    //         },
    //         () =>
    //             StageService.getStageUsers(
    //                 stageId,
    //                 "proceed",
    //                 this.props.caseId
    //             ).then(_ => {
    //                 this.setState({
    //                     usersLoading: false,
    //                     users: _.data.map(__ => ({
    //                         value: __.id,
    //                         label: __.full_name
    //                     }))
    //                 });
    //             })
    //     );
    // };

    onUserChange = userId => {
        this.setState({
            userId
        });
    };

    onChangeRemarks = val => {
        this.props.onChange({
            userId: this.state.userId,
            stageId: this.state.stage,
            remarks: `${val.target.value} | ${this.state.selectedSubStatus}`
        }) && message.success("Case Proceed Successfully");
    }

    isSelectedStageBucket =() => {
        if(this.state.stages && this.state.stages.size && this.state.stage) {
            let selectedStageIsBucket = (this.state.stages.find(_ => _.id === this.state.stage) || {}).is_bucket_available;
            if(selectedStageIsBucket) {
                return true;
            }
        }
        return false;
    }
     browserHistory = createBrowserHistory();
     render() {
         if(this.props.stageId == 2) {
             return (
                 <Row>
                     <Col span={24} className={"p-5"}>
                         <Input.TextArea placeholder={"Remarks"} onChange={this.onChangeRemarks} autosize={{minRows:2, maxRows: 3}} />
                     </Col>
                 </Row>
             );
         }
        
         if(this.state.disableForm) {
             return (
                 <div className={"text-align-center"}>
                     <Spin />
                 </div>
             );
         }
         
         return (
             <Row>
                 {this.state.stages && 
                (this.state.stages.size === 1 || this.state.stages.length === 1) && 
                this.state.user && 
                (this.state.user.size === 1 || this.state.user.length === 1) ?
                     null :
                     (<React.Fragment>
                         <p>* All the fields are mandatory</p>
                         {this.browserHistory?.location?.state.overdueCaseIds?.length > 0 && <p>Overdue Case ids: {this.browserHistory?.location?.state.overdueCaseIds.join(" ") } </p>}
                         {this.browserHistory?.location?.state.overdueCaseIds?.length > 0 && <p style={{color:"red"}}>Are you sure you want to proceed with overdue cases?</p>}
                         <Col span={12} className={"px-5"}>
                             <Select
                                 placeholder={"Select a stage"}
                                 style={{ width: "100%" }}
                                 // mode="multiple"
                                 label={"Stage"}
                                 key={"can-procced"}
                                 defaultValue={this.state.stages && this.state.stages?.toJS()[0]?.stage_name}
                                 onSelect={value => this.onStageSelect(value)}
                             >
                                 {this.state.stages.map(_ => (
                                     <Select.Option key={_.id} value={String(_.id)}>
                                         {_.stage_name}
                                     </Select.Option>
                                 ))}
                             </Select>
                         </Col>
                         <Col span={12} className={"px-5"}>
                             {!this.isSelectedStageBucket() ? (
                                 <Select
                                     disabled={this.state.isUserDisabled}
                                     placeholder={"Select a user"}
                                     style={{ width: "100%" }}
                                     onChange={this.onUserChange}
                                     key={"users"}
                                 >
                                     {this.state.stage
                                         ? this.state.stages
                                             .find(_ => _.id === this.state.stage)
                                             .user_list.map(_ => (
                                                 <Select.Option
                                                     key={_.id}
                                                     value={_.id}
                                                     full_name
                                                 >
                                                     {_.full_name}
                                                 </Select.Option>
                                             ))
                                         : []}
                                 </Select>
                             ) : null}
                         </Col>
                     </React.Fragment>)
                 }
                 {this.props.stageId ===24 && <Col span={12} className={"px-5"}>
                     <Select
                         placeholder={"Select a Sub-Status"}
                         style={{ width: "100%" }}
                         // mode="multiple"
                         label={"Sub-Status"}
                         key={"can-procced"}
                         rules= {[
                             {
                                 required: true,
                                 message: "Field is required"
                             }
                         ]}
                         onSelect={value => this.setState({selectedSubStatus:value})}
                     >
                         {this.state.subStatus.map(_ => (
                             <Select.Option key={_} value={_}>
                                 {_}
                             </Select.Option>
                         ))}
                     </Select>
                 </Col>
                 }
                 <Col span={24} className={"p-5"}>
                     <Input.TextArea placeholder={"Remarks"} onChange={this.onChangeRemarks} autosize={{minRows:2, maxRows: 3}} />
                 </Col>
             </Row>
         );
     }
}

ProceedModalContent.propTypes = {
    onChange: PropTypes.func,
    stagePermissions: PropTypes.object,
    stage: PropTypes.string,
    stageId: PropTypes.number,
    stages: PropTypes.object,
    history: PropTypes.object,
    caseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

const mapStateToProps = state => {
    return {
        stagePermissions: state.stagePermissions.get("data"),
        stages: state.stages.get("data")
    };
};
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProceedModalContent);
